import { AxiosResponse } from "axios";
import service from "../api/api.services";
import { getAPIURL, getLicenseKey } from "./application.settings";

const api = service()

export const getProductDetails = (productDetailsId: any, lotId: any, isDropdown: any, success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.get(getAPIURL() + `getProductDetails/${getLicenseKey}/${productDetailsId}/${lotId}/${isDropdown}`,
        response => {
            success(response)
        },
        error => {
            failure("getProductDetails - " + error.message)
            console.log('error caught in service : getProductDetails')
        },
    );

export const addProductDetails = (productDetailsPostData: any, success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.post(getAPIURL() + `addProductDetails`, productDetailsPostData,
        response => {
            success(response)
        },
        error => {
            failure(error.message)
            console.log('error caught in service : addProductDetails')
        }
    );


export const getProductDetailsCount = (lotId: any, isDropdown: any, success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.get(getAPIURL() + `getProductDetailsCount/${getLicenseKey}/${lotId}/${isDropdown}`,
        response => {
            success(response)
        },
        error => {
            failure("getProductDetailsCount - " + error.message)
            console.log('error caught in service : getProductDetailsCount')
        },
    );

export const getProductDetailsStock = (lotId: any, isDropdown: any, success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.get(getAPIURL() + `getProductDetailsStock/${getLicenseKey}/${lotId}/${isDropdown}`,
        response => {
            success(response)
        },
        error => {
            failure("getProductDetailsStock - " + error.message)
            console.log('error caught in service : getProductDetailsStock')
        },
    );

export const getDispatchProduct = (success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.get(getAPIURL() + `getDispatchProduct/${getLicenseKey}`,
        response => {
            success(response)
        },
        error => {
            failure("getDispatchProduct - " + error.message)
            console.log('error caught in service : getDispatchProduct')
        },
    );

export const getProductAssignDetails = (success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.get(getAPIURL() + `getProductAssignDetails/${getLicenseKey}`,
        response => {
            success(response)
        },
        error => {
            failure("getProductAssignDetails - " + error.message)
            console.log('error caught in service : getProductAssignDetails')
        },
    );


export const addDispatchProduct = (dispatchProductPostData: any, success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.post(getAPIURL() + `addDispatchProduct`, dispatchProductPostData,
        response => {
            success(response)
        },
        error => {
            failure(error.message)
            console.log('error caught in service : addDispatchProduct')
        }
    );

export const assignProduct = (assignProductPostData: any, success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.post(getAPIURL() + `assignProduct`, assignProductPostData,
        response => {
            success(response)
        },
        error => {
            failure(error.message)
            console.log('error caught in service : assignProduct')
        }
    );

export const updateAssignedProductDetails = (dispatchProductPostData: any, success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.post(getAPIURL() + `updateAssignedProductDetails`, dispatchProductPostData,
        response => {
            success(response)
        },
        error => {
            failure(error.message)
            console.log('error caught in service : updateAssignedProductDetails')
        }
    );

export const deleteProductAssign = (productAssignPostData: any, success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.post(getAPIURL() + `deleteProductAssign`, productAssignPostData,
        response => {
            success(response)
        },
        error => {
            failure(error.message)
            console.log('error caught in service : deleteProductAssign')
        }
    );

export const getChallanDetails = (success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.get(getAPIURL() + `getChallanDetails/${getLicenseKey}/0`,
        response => {
            success(response)
        },
        error => {
            failure("getChallanDetails - " + error.message)
            console.log('error caught in service : getChallanDetails')
        },
    );

export const getDispatchListByDate = (date: any, companyDetailsId: any, success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.get(getAPIURL() + `getDispatchListByDate/${getLicenseKey}/${companyDetailsId}/${date}`,
        response => {
            success(response)
        },
        error => {
            failure("getDispatchListByDate - " + error.message)
            console.log('error caught in service : getDispatchListByDate')
        },
    );

export const getAvrDispatchListByDate = (date: any, companyDetailsId: any, success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.get(getAPIURL() + `getAvrDispatchListByDate/${getLicenseKey}/${date}/${companyDetailsId}`,
        response => {
            success(response)
        },
        error => {
            failure("getAvrDispatchListByDate - " + error.message)
            console.log('error caught in service : getAvrDispatchListByDate')
        },
    );

export const updatePackingDetails = (packingPostData: any, success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.post(getAPIURL() + `updatePackingDetails`, packingPostData,
        response => {
            success(response)
        },
        error => {
            failure(error.message)
            console.log('error caught in service : updatePackingDetails')
        }
    );

export const updateDeliveryChallan = (challanPostData: any, success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.post(getAPIURL() + `updateDeliveryChallan`, challanPostData,
        response => {
            success(response)
        },
        error => {
            failure(error.message)
            console.log('error caught in service : updateDeliveryChallan')
        }
    );

export const updateDeliveryChallanDetails = (challanPostData: any, success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.post(getAPIURL() + `updateDeliveryChallanDetails`, challanPostData,
        response => {
            success(response)
        },
        error => {
            failure(error.message)
            console.log('error caught in service : updateDeliveryChallanDetails')
        }
    );

export const updateInvoiceDetails = (invoicePostData: any, success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.post(getAPIURL() + `updateInvoiceDetails`, invoicePostData,
        response => {
            success(response)
        },
        error => {
            failure(error.message)
            console.log('error caught in service : updateInvoiceDetails')
        }
    );

export const getDeliveryChallanList = (deliveryChallanId: any, success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.get(getAPIURL() + `getDeliveryChallanList/${getLicenseKey}/${deliveryChallanId}`,
        response => {
            success(response)
        },
        error => {
            failure("getDeliveryChallanList - " + error.message)
            console.log('error caught in service : getDeliveryChallanList')
        },
    );

export const getDeliveryChallanDetails = (success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.get(getAPIURL() + `getDeliveryChallanDetails/${getLicenseKey}`,
        response => {
            success(response)
        },
        error => {
            failure("getDeliveryChallanDetails - " + error.message)
            console.log('error caught in service : getDeliveryChallanDetails')
        },
    );

export const addInvoice = (invoicePostData: any, success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.post(getAPIURL() + `addInvoice`, invoicePostData,
        response => {
            success(response)
        },
        error => {
            failure(error.message)
            console.log('error caught in service : addInvoice')
        }
    );

export const getInvoiceList = (invoiceId: any, success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.get(getAPIURL() + `getInvoiceList/${getLicenseKey}/${invoiceId}`,
        response => {
            success(response)
        },
        error => {
            failure("getInvoiceList - " + error.message)
            console.log('error caught in service : getInvoiceList')
        },
    );

export const getInvoiceDetails = (success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.get(getAPIURL() + `getInvoiceDetails/${getLicenseKey}`,
        response => {
            success(response)
        },
        error => {
            failure("getInvoiceDetails - " + error.message)
            console.log('error caught in service : getInvoiceDetails')
        },
    );


export const updateInvoice = (invoicePostData: any, success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.post(getAPIURL() + `updateInvoice`, invoicePostData,
        response => {
            success(response)
        },
        error => {
            failure(error.message)
            console.log('error caught in service : updateInvoice')
        }
    );

export const addSubInvoice = (invoicePostData: any, success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.post(getAPIURL() + `addSubInvoice`, invoicePostData,
        response => {
            success(response)
        },
        error => {
            failure(error.message)
            console.log('error caught in service : addSubInvoice')
        }
    );

export const getSubInvoiceList = (subInvoiceId: any, success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.get(getAPIURL() + `getSubInvoiceList/${getLicenseKey}/${subInvoiceId}`,
        response => {
            success(response)
        },
        error => {
            failure("getSubInvoiceList - " + error.message)
            console.log('error caught in service : getSubInvoiceList')
        },
    );

export const updateSubInvoice = (invoicePostData: any, success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.post(getAPIURL() + `updateSubInvoice`, invoicePostData,
        response => {
            success(response)
        },
        error => {
            failure(error.message)
            console.log('error caught in service : updateSubInvoice')
        }
    );

export const updateSubInvoiceDetails = (invoicePostData: any, success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.post(getAPIURL() + `updateSubInvoiceDetails`, invoicePostData,
        response => {
            success(response)
        },
        error => {
            failure(error.message)
            console.log('error caught in service : updateSubInvoiceDetails')
        }
    );

export const getSubDispatchListByDate = (date: any, companyDetailsId: any, success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.get(getAPIURL() + `getSubDispatchListByDate/${getLicenseKey}/${companyDetailsId}/${date}`,
        response => {
            success(response)
        },
        error => {
            failure("getSubDispatchListByDate - " + error.message)
            console.log('error caught in service : getSubDispatchListByDate')
        },
    );

export const getSubInvoiceDetails = (invoiceUniqueNo: any, success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.get(getAPIURL() + `getSubInvoiceDetails/${getLicenseKey}/${invoiceUniqueNo}`,
        response => {
            success(response)
        },
        error => {
            failure("getSubInvoiceDetails - " + error.message)
            console.log('error caught in service : getSubInvoiceDetails')
        },
    );

export const getProductStockReport = (fromDate: any, toDate: any, success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.get(getAPIURL() + `getProductStockReport/${getLicenseKey}/${fromDate}/${toDate}`,
        response => {
            success(response)
        },
        error => {
            failure("getProductStockReport - " + error.message)
            console.log('error caught in service : getProductStockReport')
        },
    );
export const getProduct = (success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.get(getAPIURL() + `getProduct/${getLicenseKey}`,
        response => {
            success(response)
        },
        error => {
            failure("getProduct - " + error.message)
            console.log('error caught in service : getProduct')
        },
    );

export const getSubModuleType = (id: any, success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.get(getAPIURL() + `getSubModuleType/${getLicenseKey}/${id}`,
        response => {
            success(response)
        },
        error => {
            failure("getSubModuleType - " + error.message)
            console.log('error caught in service : getSubModuleType')
        },
    );

export const addProduct = (productPostData: any, success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>

    api.post(getAPIURL() + `addProduct`, productPostData,
        response => {
            success(response)
        },
        error => {
            failure("addProduct - " + error.message)
            console.log('error caught in service : addProduct')
        }
    );
export const updateProduct = (productPostData: any, success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>
    api.post(getAPIURL() + `updateProduct`, productPostData,
        response => {
            success(response)
        },
        error => {
            failure("updateProduct - " + error.message)
            console.log('error caught in service : updateProduct')
        }
    );

export const deleteProduct = (productPostData: any, success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>
    api.post(getAPIURL() + `deleteProduct`, productPostData,
        response => {
            success(response)
        },
        error => {
            failure("deleteProduct - " + error.message)
            console.log('error caught in service : deleteProduct')
        }
    );

export const updateMobileVisibility = (productPostData: any, success: (arg0: AxiosResponse<any, any>) => any, failure: (arg0: any) => void,) =>
    api.post(getAPIURL() + `updateMobileVisibility`, productPostData,
        response => {
            success(response)
        },
        error => {
            failure("updateMobileVisibility - " + error.message)
            console.log('error caught in service : updateMobileVisibility')
        }
    );
